import React, { useCallback, useState } from 'react';
import Loader from 'components/Loader';

function Image({ alt, ...props }) {
    const [loaded, setLoaded] = useState(false);
    const onLoad = useCallback(() => {
        setLoaded(true);
    }, []);

    return (
        <div style={{ position: 'relative', width: '100%', height: '100%' }}>
            <img {...props} alt={alt} onLoad={onLoad} />
            {!loaded && <Loader />}
        </div>
    );
}

export default Image;
